// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"3ed2a717","549":"f566d771"}[chunkId] + ".chunk.js";
};